import { render, staticRenderFns } from "./ApexBarGraph.vue?vue&type=template&id=44b9427d&"
import script from "./ApexBarGraph.vue?vue&type=script&lang=js&"
export * from "./ApexBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports